import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import CollegeCard from "../../ui/CollegeCard";
import Reveal from "../../ui/Reveal";
import SectionHeading from "../../ui/SectionHeading";

function FeaturedCollegeStrip({ colleges = [] }) {
  return (
    <section>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHeading
          badge="Curated Institutions"
          title="Institutions commonly reviewed during counselling"
          description="A curated subset from our broader state-wise college coverage list."
        />
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand-navy hover:text-brand-gold-strong"
        >
          Get shortlist guidance
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {colleges.map((college, index) => (
          <Reveal key={college.id} delay={index * 0.04}>
            <CollegeCard
              college={college}
              minimal
              showCta={false}
              className={index % 3 === 1 ? "md:-mt-6" : ""}
            />
          </Reveal>
        ))}
      </div>
    </section>
  );
}

export default FeaturedCollegeStrip;
